import React, { Dispatch, FC, SetStateAction } from "react";

export type PopUp = {
  CompoToRender?: FC;
};

type PopUpDisplayContext = {
  popUpsDisplayed: PopUp[];
  setPopUpsDisplayed: Dispatch<SetStateAction<PopUp[]>>;
  addPopUp: (popUp: PopUp) => void;
  removeSpecificPopUp: (index: number) => void;
};

export default React.createContext<PopUpDisplayContext>({
  popUpsDisplayed: [],
  setPopUpsDisplayed: (value) => {},
  addPopUp: (value) => {},
  removeSpecificPopUp: (value) => {},
});
